// ─── CHAD V3 Project Registry ────────────────────────────────────────────────
// Lightweight config — only metadata, no data rows.
// All actual project data comes from Google Sheets via /api/sheets.
// TODO: Migrate to a "Projects" master Google Sheet so this file is unnecessary.
// ─────────────────────────────────────────────────────────────────────────────

export const DIVISIONS = {
  gc: {
    id: "gc",
    company: "CHAD Construction",
    division: "General Contracting",
    shortName: "CHAD GC",
    code: "GC",
    color: "#d4a04a",
    projects: {
      sunset: {
        id: "sunset",
        name: "Sunset Medical Center",
        number: "GC-2024-08",
        code: "SM",
        location: "Hollywood, CA",
        value: "$142M",
        status: "Active",
      },
      wilshire: {
        id: "wilshire",
        name: "Wilshire Office Tower",
        number: "GC-2025-03",
        code: "WT",
        location: "Mid-Wilshire, LA",
        value: "$98M",
        status: "Active",
      },
      harbor: {
        id: "harbor",
        name: "Harbor Parking Structure",
        number: "GC-2025-06",
        code: "HP",
        location: "San Pedro, CA",
        value: "$34M",
        status: "Preconstruction",
        sheetsConnected: false,
      },
    },
  },
  concrete: {
    id: "concrete",
    company: "CHAD Construction",
    division: "Concrete Division",
    shortName: "CHAD Concrete",
    code: "CC",
    color: "#7ec8a4",
    projects: {
      downtown: {
        id: "downtown",
        name: "Downtown Mixed-Use",
        number: "CC-2025-01",
        code: "DM",
        location: "Downtown LA",
        value: "$67M",
        status: "Active",
      },
      lax: {
        id: "lax",
        name: "LAX Terminal Expansion",
        number: "CC-2025-02",
        code: "LX",
        location: "Los Angeles, CA",
        value: "$210M",
        status: "Active",
      },
    },
  },
};

// Flat list for iteration
export const DIVISION_LIST = Object.values(DIVISIONS);

// Get all projects as a flat array
export function getAllProjects() {
  const projects = [];
  DIVISION_LIST.forEach(div => {
    Object.values(div.projects).forEach(proj => {
      projects.push({ ...proj, divId: div.id, divColor: div.color, divShort: div.shortName });
    });
  });
  return projects;
}

// Lookup helpers
export function getDivision(divId) { return DIVISIONS[divId] || null; }
export function getProject(divId, projId) { return DIVISIONS[divId]?.projects?.[projId] || null; }
